import React from 'react';
import Select from 'react-select'
import { ErrorMessage } from 'formik';

function ValidatedMultiSelectField(props) {
    let { className, styles } = props;
    const { name, values, label, placeholder, options, readOnly, errors, touched, onChange, onBlur } = props;

    let showError = errors[name] && touched[name];
    if (showError) {
        className += " is-invalid";
    }

    const handleChange = value => {
        if (value) {
            onChange(name, value.map(item => item.value));
        }
        else {
            onChange(name, []);
        }
    };

    const handleBlur = () => {
        onBlur(name, true);
    };

    return (
        <div className="form-group">
            {label && <label htmlFor={name}>{label}</label>}
            <Select
                id={name}
                placeholder={placeholder}
                options={options}
                value = {options.filter(option => values[name].includes(option.value))}
                readOnly={readOnly}
                className={className}
                styles={styles}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched[name]}
                error={errors[name]}
                isMulti={true}
            />
            <ErrorMessage name={name} component="div" className="invalid-feedback" />
        </div>
    )
}

export default ValidatedMultiSelectField;
